export default __webpack_public_path__ + "static/media/Kanishk.a5812327.jpg";